import { basename, extname } from "../../src/common/path";
import War3MapViewer from "../../src/viewer/handlers/w3x/viewer";
import { setupCamera } from "../shared/camera";
import localOrHive from "../shared/localorhive";

let statusElement = document.getElementById("status");
statusElement.textContent = "Initializing the viewer";

let canvas = document.getElementById("canvas");
let camera;

// true because the Reforged Hive API is used in localOrHive.
let viewer = new War3MapViewer(canvas, localOrHive, true);

let thingsLoading = [];
let firstLoad = true;

async function getFileFromUrl(
  url,
  name,
  defaultType = "application/octet-stream"
) {
  /*const response = await fetch(url, { credentials: 'omit' });
  const data = await response.blob();
  return new File([data], name, {
    type: data.type || defaultType,
  });*/
  const urlParams = new URLSearchParams(window.location.search);
  const mapPath = urlParams.get("path");

  // Start the fetch and obtain a reader
  let response = await fetch(url);

  const reader = response.body.getReader();

  // get total length
  const contentLength = +response.headers.get("Content-Length");

  // read the data
  let receivedLength = 0; // received that many bytes at the moment
  let chunks = []; // array of received binary chunks (comprises the body)
  while (true) {
    const { done, value } = await reader.read();

    if (done) {
      break;
    }

    chunks.push(value);
    receivedLength += value.length;

    const percentage = Math.floor( (receivedLength / contentLength) * 100 )

    statusElement.textContent = `Downloading ${mapPath} (${percentage}%)`;
  }

  return new File(chunks, name, {
    type: 'application/octet-stream',
  });
}

function updateStatus() {
  if (thingsLoading.length) {
    statusElement.textContent = `Loading ${thingsLoading.join(", ")}`;
  } else {
    statusElement.textContent = "";
  }
}

for (let key of viewer.promiseMap.keys()) {
  thingsLoading.push(basename(key));
}

updateStatus();

viewer.on("loadstart", ({ fetchUrl }) => {
  thingsLoading.push(basename(fetchUrl));
  updateStatus();
});

viewer.on("loadend", async ({ fetchUrl }) => {
  let file = basename(fetchUrl);
  let index = thingsLoading.indexOf(file);

  if (index !== -1) {
    thingsLoading.splice(index, 1);
    updateStatus();
  }

  if (thingsLoading.length === 0 && firstLoad) {
    firstLoad = false;

    try {
      const urlParams = new URLSearchParams(window.location.search);
      const mapId = urlParams.get("map");
      const mapPath = urlParams.get("path");
      const clip = Number(urlParams.get("clip")) || 20000;

      statusElement.textContent = `Downloading ${mapPath}...`;

      const file = await getFileFromUrl(
        `https://f005.backblazeb2.com/file/wc3maps/${mapId}/${mapPath}`,
        mapPath
      );
      let reader = new FileReader();

      reader.addEventListener("loadend", (e) => {
        viewer.loadMap(e.target.result);

        camera = setupCamera(viewer.map.worldScene, {
          distance: 3000,
          farClipPlane: clip,
        });
      });

      statusElement.textContent = `Parsing ${mapPath}...`;

      reader.readAsArrayBuffer(file);
    } catch (e) {
      statusElement.textContent = `${e}`;
    }
  }
});

let meter = new FPSMeter({
  position: "absolute",
  right: "10px",
  top: "10px",
  left: "calc(100% - 130px)",
  theme: "transparent",
  heat: 1,
  graph: 1,
});

let cellsElement = document.getElementById("cells");
let instancesElement = document.getElementById("instances");
let particlesElement = document.getElementById("particles");

(function step() {
  requestAnimationFrame(step);

  viewer.updateAndRender();
  meter.tick();

  cellsElement.textContent = `Cells: ${viewer.visibleCells}`;
  instancesElement.textContent = `Instances: ${viewer.visibleInstances}`;
  particlesElement.textContent = `Particles: ${viewer.updatedParticles}`;
})();

document.addEventListener("dragover", (e) => {
  e.preventDefault();
});

document.addEventListener("dragend", (e) => {
  e.preventDefault();
});
